<template>
  <div>
    <h2 class="step-name">Deer - Trace Elements</h2>

    <div class="step-section">
      <radio-input
        label="Do you do any trace element testing?"
        field-name="deer_trace_element_testing"
        :add-comment="true"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>
    </div>
    <hr />

    <div class="step-section">
      <div>
        <h3>SSe</h3>
        <template v-if="sse_data.length > 0">
          <box-plot-chart :chart-data="get_sse_data" />
        </template>
        <span v-else>No Results</span>
      </div>

      <div>
        <h3>LSe</h3>
        <template v-if="lse_data.length > 0">
          <box-plot-chart :chart-data="get_lse_data" />
        </template>
        <span v-else>No Results</span>
      </div>

      <div>
        <h3>SCU</h3>
        <template v-if="scu_data.length > 0">
          <box-plot-chart :chart-data="get_scu_data" />
        </template>
        <span v-else>No Results</span>
      </div>

      <div>
        <h3>LCu</h3>
        <template v-if="lcu_data.length > 0">
          <box-plot-chart :chart-data="get_lcu_data" />
        </template>
        <span v-else>No Results</span>
      </div>
    </div>

    <div class="step-section">
      <discussion-points
        title="Deer Trace Element Testing"
        comments-field="deer_te_testing_notes"
        points="Product used, injection/capsule/oral/salts"
      >
      </discussion-points>

      <discussion-points
        title=""
        comments-field="deer_want_animal_health_plan_discussion"
        points="start of velveting, weaning date, Yersiniavax times, TB testing"
      >
        <radio-input
          label="Do you want an Animal Health Plan for your deer?"
          field-name="deer_want_animal_health_plan"
          :choices="[
            { value: 'Yes', display: 'Yes' },
            { value: 'No', display: 'No' },
          ]"
          :add-comment="true"
        >
        </radio-input>
      </discussion-points>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import BoxPlotChart from '@/components/charts/BoxPlotChart'

export default {
  name: 'DeerTraceElements',
  mixins: [baseComponent],
  components: {
    BoxPlotChart,
  },
  methods: {
    getLabels(data) {
      return data.map((row) => row['Date'])
    },
    getData(data) {
      return data.map((row) => row['res'].split(', ').map((n) => parseFloat(n)))
    },
  },
  computed: {
    sse_data: function () {
      return this.getData(this.getChartData('deer_sse_results'))
    },
    get_sse_data: function () {
      return {
        labels: this.getLabels(this.getChartData('deer_sse_results')),
        datasets: [
          {
            label: 'SSe',
            borderWidth: 2,
            borderColor: 'rgba(0, 0, 0, .4)',
            backgroundColor: 'rgba(51, 122, 183, 0.6)',
            data: this.sse_data,
          },
        ],
      }
    },
    lcu_data: function () {
      return this.getData(this.getChartData('deer_lcu_results'))
    },
    get_lcu_data: function () {
      return {
        labels: this.getLabels(this.getChartData('deer_lcu_results')),
        datasets: [
          {
            label: 'LCu',
            borderWidth: 2,
            borderColor: 'rgba(0, 0, 0, .4)',
            backgroundColor: 'rgba(51, 122, 183, 0.6)',
            data: this.lcu_data,
          },
        ],
      }
    },
    scu_data: function () {
      return this.getData(this.getChartData('deer_scu_results'))
    },
    get_scu_data: function () {
      return {
        labels: this.getLabels(this.getChartData('deer_scu_results')),
        datasets: [
          {
            label: 'SCu',
            borderWidth: 2,
            borderColor: 'rgba(0, 0, 0, .4)',
            backgroundColor: 'rgba(51, 122, 183, 0.6)',
            data: this.scu_data,
          },
        ],
      }
    },
    lse_data: function () {
      return this.getData(this.getChartData('deer_lse_results'))
    },
    get_lse_data: function () {
      return {
        labels: this.getLabels(this.getChartData('deer_lse_results')),
        datasets: [
          {
            label: 'LSe',
            borderWidth: 2,
            borderColor: 'rgba(0, 0, 0, .4)',
            backgroundColor: 'rgba(51, 122, 183, 0.6)',
            data: this.lse_data,
          },
        ],
      }
    },
  },
}
</script>
